import React from "react";
import { Box } from "@mui/material";
import "./MapLoadScreen.css"; // Ensure you have this CSS file for styles

const MapLoadScreenMobile = () => {
  return (
    <Box
      sx={{
        width: "200px",
        height: "200px",
      }}
    >
      <svg
        viewBox="0 0 32 32"
        style={{
          width: "100%",
          height: "100%",
          animation: "spin 1s linear infinite",
        }}
      >
        <circle cx="16" cy="16" r="15" fill="transparent" stroke="#f3f3f3" />
        <circle
          cx="16"
          cy="16"
          r="15"
          fill="transparent"
          stroke="orange"
          strokeDasharray="75 25"
          strokeLinecap="round"
        />
      </svg>
    </Box>
  );
};

export default MapLoadScreenMobile;
